<template>
	<!-- Bottom left, above the status panel: the top bar is a window drag region in the desktop shell, which would take a click on a toast -->
	<Toast position="bottom-left" :style="{ bottom: '36px' }" />
</template>

<script setup lang="ts">
/**
 * Shows the toasts asked for with the global CommonToast event: short messages that go away by themselves, for what
 * needs no answer - the error modal is for what does
 */

import { onBeforeUnmount } from 'vue'
import { useToast } from 'primevue/usetoast'
import globalEvents from '@/utilities/GlobalEvents'
import type { ToastMessage } from '@/definitions/Common'

/** How long a toast stays */
const TOAST_LIFE_MS = 6000

const toast = useToast()

function show(message: ToastMessage) {
	toast.add({ severity: message.severity, summary: message.summary, detail: message.detail, life: TOAST_LIFE_MS })
}

globalEvents.on('CommonToast', show)

onBeforeUnmount(() => { globalEvents.off('CommonToast', show) })
</script>
